import React, { useEffect, useState } from "react";
import { Button, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import FormSelect from "../../../Controls/Select";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import history from "../../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Roles from "../../../constants/Roles";
import { getCarrerasProgramas } from "services/ConvenioService";
import { findByNumeroCedula } from "services/DatosPersonalesService";
import { trackPromise } from "react-promise-tracker";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
}));

const Form = () => {
  const classes = useStyles();
  const [carreraOptions, setCarreraOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [tutoresResponseData, setTutoresResponseData] = useState({});
  const params = useParams();
  const methods = useForm({});
  const { handleSubmit, errors, setValue, reset } = methods;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const { hasRole } = useAuth();
  let { state } = useLocation();
  const [idTutor, setIdTutor] = useState();
  const [fechaCreacion, setFechaCreacion] = useState();
  const [usuarioCreacion, setUsuarioCreacion] = useState();
  const [isPostgrado, setIsPostgrado] = useState(false);
  const [isNotReg, setIsNotReg] = useState(false);
  const [postgradoId, setPostgradoId] = useState();
  
  useEffect(() => {
    const load = () => {
      try {
        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit);
          setIsReadOnly(state?.readOnly);
          setValuesForEdit();
        } else {
          getServerData();
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async () => {
    try {

      const { data: responseCarreraProgramaData } = await getCarrerasProgramas(params.convenioId);
      loadCarreraOptions(responseCarreraProgramaData);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const loadCarreraOptions = (carreras) => {
        if(carreras[0]?.carreraPrograma?.descripcion ==='Postgrado'){
          setIsPostgrado(true);
          setPostgradoId(carreras[0].carreraPrograma.id);
          setCarreraOptions(     
            carreras.map((carrera) => (
            {label: "Postgrado - " +  carrera.nombrePostgrado.descripcion,
            id: carrera.nombrePostgrado.id }
            ))
          );

        }else{
          setCarreraOptions(     
            carreras.map((carrera) => (
            { label: carrera.carreraPrograma.descripcion,
            id: carrera.carreraPrograma.id }
            ))
          );

        } 
       /*setCarreraOptions(
        carreras.map((carrera) => ({
          label: carrera.carreraPrograma.descripcion,
          id: carrera.carreraPrograma.id
        }))
      );*/
 
  }

  const setValuesForEdit = async () => {
    try {

      let { convenioTutorId } = params;

      const { data: tutoresResponseData } = await DnerhsApi.get(`/convenios/tutores/${convenioTutorId}`);

      setTutoresResponseData(tutoresResponseData);
      setFechaCreacion(tutoresResponseData.tutor.fechaCreacion);
      setUsuarioCreacion(tutoresResponseData.tutor.idUsuarioCreacion)
      setIdTutor(tutoresResponseData.tutor.id)

      const { data: responseCarreraProgramaData } = await DnerhsApi.get(`/convenios/${tutoresResponseData?.convenio.id}/carreras-programas`, {
        params: { pageSize: 100 },
      });

      let { tutor } = tutoresResponseData;

      const formValues = {
        cedulaIdentidad: tutoresResponseData.tutor.cedulaIdentidad,
        apellido: tutoresResponseData.tutor.apellidos,
        nombre: tutoresResponseData.tutor.nombres,
        email: tutoresResponseData.tutor.email,
        carrera: tutoresResponseData.carrera.descripcion==="Postgrado"?  tutoresResponseData.nombrePostgrado.id :  tutoresResponseData.carrera.id,
        numeroRegistroProfesional: tutoresResponseData.tutor.numeroRegistroProfesionalVigente,
        materia: tutoresResponseData.materia,
        curso: tutoresResponseData.curso
      };

      Object.keys(formValues).forEach((field) => setValue(field, formValues[field]));

      loadCarreraOptions(responseCarreraProgramaData);

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }

  const onSubmit = async (data) => {

    if (data.carrera === "") {
      showMessageError("El campo carrera es dato requerido");
      return;
    }

    let url = "/convenios/tutores";

    const tutorDataForm = {
      cedulaIdentidad: data.cedulaIdentidad,
      apellidos: data.apellido,
      nombres: data.nombre,
      email: data.email,
      numeroRegistroProfesionalVigente: data.numeroRegistroProfesional,
      id: idTutor,
      fechaCreacion:fechaCreacion,
      idUsuarioCreacion:usuarioCreacion
    };

    try {   
      let message = "";

      let nombrePostgradoIdVar=0;
      if (isUpdate) {
        let payloadUpt = { ...tutoresResponseData };
        payloadUpt.tutor = tutorDataForm;
        payloadUpt.carrera=isPostgrado? { id: postgradoId } :{ id: data.carrera };
        payloadUpt.materia= data.materia;
        payloadUpt.Alertcurso= data.curso;
        payloadUpt.nombrePostgrado=isPostgrado? { id: data.carrera } :{ id: nombrePostgradoIdVar };
        await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));

        message = "Datos guardados exitosamente."

      } else {
        let payloadNew = {
          convenio: {
            id: params.convenioId,
          },
          tutor: tutorDataForm,
          carrera: isPostgrado? { id: postgradoId } :{ id: data.carrera },
          materia: data.materia,
          curso: data.curso,
          nombrePostgrado:isPostgrado? { id: data.carrera } :{ id: nombrePostgradoIdVar }
        }

        await trackPromise(DnerhsApi.post(url, {
          ...payloadNew,
        }));

        message = "Datos actualizados exitosamente."
      }

      Alert.show({
        message,
        type: "success"
      })

      history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }
  const handleFindDatosTutor = async (event) => {
    let { target } = event;
    const {data } = await trackPromise(DnerhsApi.get(`/establecimientos-profesiones-profesionales/cedula/${target.value}`));//CAMBIAR URL
    if (data.length>0) {
      if(data[0].profesional.habilitado){     
        setFechaCreacion(data[0].fechaCreacion);
        setUsuarioCreacion(data[0].idUsuarioCreacion);
        setValue("nombre", data[0].profesional.nombres);
        setValue("apellido", data[0].profesional.apellidos);
        setValue("email", data[0].profesional.email);
        setValue("numeroRegistroProfesional", data[0].profesional.numeroRegistroProfesionalVigente);
        setIsNotReg(false);
      }else{
        let messageNoHabilitado="No se pudo obtener los datos, el tutor no se encuentra habilitado por DNERHS";
        Alert.show({
          message:"No se pudo obtener los datos, el tutor no se encuentra habilitado por DNERHS",
          type: "warning"
        });
      }
    }else{
      //handleFindDatosPersonales(target.value); //se debe eliminar esta busqueda
      let message = "No se encuentra registro profesional, No se puede continuar";
      Alert.show({
        message,
        type: "error"
      });
      setFechaCreacion("");
      setUsuarioCreacion("");

      setValue("nombre","");
      setValue("apellido", "");
      setValue("email", "");
      setValue("numeroRegistroProfesional", "");
      setIsNotReg(true);
    }
  };
  const handleFindDatosPersonales = async (event) => {

    const { data } = await trackPromise(findByNumeroCedula(event));
    if (data) {
      setValue("nombre", data.nombres);
      setValue("apellido", data.apellidos);
    }
  };


  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }

  return (
    <div>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" color="primary">
          Tutor
        </Typography>
      </Grid>
      <div>
        <FormProvider {...methods}>
          <form>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item xs={6} className={classes.form}>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    type="number"
                    name="cedulaIdentidad"
                    label="Cédula de Identidad"
                    onBlur={handleFindDatosTutor}
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="apellido"
                    label="Apellidos"
                    disabled
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormSelect
                      name="carrera"
                      label="Carrera"
                      disabled={isReadOnly}
                      options={carreraOptions}
                    />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="numeroRegistroProfesional"
                    label="Nro. Registro Profesional"
                    disabled={isReadOnly}
                  />
                </Grid>
              </Grid>
              <Grid item xs={6} className={classes.form}>
                <Grid item xs={12} className={classes.field}>
                    <FormInput
                    name="nombre"
                    label="Nombres"
                    disabled
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput name="email" label="Email" disabled={isReadOnly} />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="materia"
                    label="Materia"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    type="number"
                    name="curso"
                    label="Curso"
                    disabled={isReadOnly}
                  />
                </Grid>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </div>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() => history.goBack()}
          >
            Atrás
          </Button>
        </Grid>
        {hasRole(Roles.ROLE_USER) && (
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isNotReg}

            >
              Guardar
            </Button>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Form;